import React from 'react'
import { bool, node, string, func } from 'prop-types'
import { useMediaQuery } from '@material-ui/core'

import { Close } from '@assets/icons'

import * as Style from './SideDialog.style'

export default function SideDialog({ open, title, onClose, children }) {
  const fullScreen = useMediaQuery('(max-width: 1200px)')

  return (
    <Style.Dialog
      open={open}
      fullScreen={fullScreen}
      PaperProps={{ square: true }}
      onClose={onClose}
    >
      <Style.DialogHeader>
        <Style.Title>{title}</Style.Title>
        <Style.CloseIcon src={Close} alt="Close dialog" onClick={onClose} />
      </Style.DialogHeader>
      {children}
    </Style.Dialog>
  )
}

SideDialog.propTypes = {
  open: bool,
  title: string,
  onClose: func,
  children: node,
}

SideDialog.defaultProps = {
  open: false,
  title: null,
  onClose: null,
  children: () => {},
}
